<template lang="pug">
div.home-articles(
    v-observe-visibility="observeVisibilityOptions")

    segment(
        v-if="firstItems.length || spotlight"
        v-bind:title="$t('home.articles')")

        template(#display-options="")
            div.display-option.show-all(
                v-if="firstItems.length && isIntersectionVisible")
                router-link(
                    v-bind:to="getLocalizedSearchRoute('Articles')")
                    icon-plus-circle-outline(title='')
                    span.label {{ $t('common.showAll') }}

        div.card-container.is-ancestor(
            v-if="isIntersectionVisible")
            div.spotlight(
                v-if="spotlight")
                feature-article-card(
                    v-bind:item="spotlight"
                    v-bind:hero="true"
                    v-bind:header="false"
                    v-bind:resolution="{x: '100vw'}"
                    v-bind:image-as-background="false"
                    v-bind:social="false")

            div.feature-articles(
                v-if="firstItems && firstItems.length")
                feature-article-card(
                    v-for="(item, index) in firstItems" v-bind:key="'a' + index"
                    v-bind:item="item"
                    v-bind:hero="true"
                    v-bind:header="false"
                    v-bind:link-to="true"
                    v-bind:resolution="{x: '80vw'}"
                    v-bind:image-as-background="false"
                    v-bind:use-palette="true"
                    v-bind:social="false"
                    v-bind:contents="true")

        //- div.tile.explore
        //-     button.btn(
        //-         v-on:click="onIngressClick('FeatureArticles')") {{ $t('common.viewAll') }}


</template>

<script>
import HeroMixin from '@/components/Home/HeroMixin.js';

export default {
    name: 'home-articles',

    mixins: [ HeroMixin ],

    data: function () {
        return {
            spotlight: null,
            firstItems: []
        };
    },

    methods: {
        initSection: function () {
            // sort by TopicDate
            const items = _.orderBy(this.items, 'TopicDate', 'desc');

            this.spotlight = _.head(items);
            this.firstItems = _.take(_.without(items, this.spotlight), 4);

            this.ready = true;
        }
    }
};
</script>

<style lang="scss">
@import '../FeatureArticle/index-cards';

.home-articles {
    padding-bottom: 25vh;
    background-color: $light-gray;
    .card-container {
        flex-basis: 320px;
        flex-wrap: wrap;
        align-items: flex-start;
        margin-left: 0;
        @include feature-article-index-cards;
    }
    .spotlight {
        .card .card-image {
            flex-grow: 2;
            @media screen and (min-width: $breakpoint-desktop) {
                height: 50vh;
            }
            figure {
                height: inherit !important;
            }
        }
        .card h2.title {
            font-size: 2rem;
        }
    }
}
</style>
